/* @flow */
import get from 'lodash.get';

import ModifyPortfolioFolderItems from '../mutations/ModifyPortfolioFolderItems';

import type { ModifyItemInFolderType } from '../types';

export default function modifyItemInFolder({
    action,
    portfolioId,
    portfolioName,
    primaryItemPk,
    relay,
    allowSavingMultipleItems,
    selectedItemIds,
    userId,
    itemNote = '',
    portfolioItemMatches = [],
    closeModal,
    trackingHooks = {},
    callbacks = {},
}: ModifyItemInFolderType): void {
    closeModal = closeModal || (() => Promise.resolve());
    const {
        onAddItemSuccess,
        onAddItemError,
        onRemoveItemSuccess,
        onRemoveItemError,
        onAddNoteSuccess,
        onAddNoteError,
        onMutationCompletion,
    } = callbacks;

    let itemsIds;
    if (allowSavingMultipleItems && selectedItemIds) {
        itemsIds = selectedItemIds;
    } else if (primaryItemPk) {
        itemsIds = [primaryItemPk];
    }

    if (itemsIds && ['ADD', 'REMOVE', 'EDIT'].indexOf(action) > -1) {
        let portfolioItemsIds = null;
        if (primaryItemPk) {
            portfolioItemsIds = portfolioItemMatches.reduce((matches, folder) => {
                if (
                    folder.portfolioId === portfolioId &&
                    get(folder, 'item.serviceId') === primaryItemPk
                ) {
                    matches.push(folder.portfolioItemId);
                }
                return matches;
            }, []);
        }

        ModifyPortfolioFolderItems.commit(relay.environment, {
            action,
            itemsIds,
            note: itemNote,
            portfolioItemsIds,
            portfolioId,
            userId,
            onCompleted: () => {
                const onCompleted = () => {
                    if (action === 'ADD') {
                        if (onAddItemSuccess) {
                            onAddItemSuccess({ portfolioName });
                        }
                        if (itemNote && onAddNoteSuccess) {
                            onAddNoteSuccess();
                        }
                        if (trackingHooks.trackItemAdded && itemsIds.length === 1) {
                            trackingHooks.trackItemAdded(!!itemNote, itemsIds[0]);
                        } else if (trackingHooks.trackItemAdded) {
                            trackingHooks.trackItemAdded(!!itemNote);
                        }
                    } else if (action === 'REMOVE') {
                        if (onRemoveItemSuccess) {
                            onRemoveItemSuccess();
                        }
                        if (trackingHooks.trackItemRemoved) {
                            trackingHooks.trackItemRemoved();
                        }
                    }
                    if (onMutationCompletion) {
                        onMutationCompletion();
                    }
                };

                if (closeModal) {
                    closeModal()
                        .then(onCompleted)
                        .catch(e => {
                            console.warn('Failed to close modal', e);
                        });
                } else {
                    onCompleted();
                }
            },
            onError: error => {
                const onError = () => {
                    if (action === 'ADD') {
                        if (onAddItemError) {
                            onAddItemError(error);
                        }
                        if (itemNote && onAddNoteError) {
                            onAddNoteError(error);
                        }
                    } else if (onRemoveItemError) {
                        onRemoveItemError(error);
                    }
                    if (onMutationCompletion) {
                        onMutationCompletion();
                    }
                };

                if (closeModal) {
                    closeModal()
                        .then(onError)
                        .catch(e => {
                            console.warn('Failed to close modal', e);
                        });
                } else {
                    onError();
                }
            },
        });
    } else {
        const onNoId = () => {
            if (action === 'ADD') {
                if (onAddItemError) {
                    onAddItemError();
                }
                if (itemNote && onAddNoteError) {
                    onAddNoteError();
                }
            } else if (onRemoveItemError) {
                onRemoveItemError();
            }
        };

        if (closeModal) {
            closeModal()
                .then(onNoId)
                .catch(e => {
                    console.warn('Failed to close modal', e);
                });
        } else {
            onNoId();
        }
    }
}
